import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";

const COLORS = ["hsl(var(--primary))", "#38bdf8", "#f472b6", "#a3e635", "#fbbf24", "#a78bfa", "#fb7185"];

export const LogisticsChart = ({ daily, packers }) => {
  const data = daily.map((d) => ({ label: `${d.date.slice(8, 10)}/${d.date.slice(5, 7)}`, ...d.by }));
  return (
    <div data-testid="logistics-chart">
      <h3 className="mb-4 font-display text-lg font-semibold">Pacchi per giorno</h3>
      {data.length === 0 ? <p className="text-sm text-muted-foreground">Nessun dato nel periodo.</p> : (
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
            <XAxis dataKey="label" stroke="hsl(var(--muted-foreground))" fontSize={12} tickLine={false} axisLine={false} />
            <YAxis stroke="hsl(var(--muted-foreground))" fontSize={12} tickLine={false} axisLine={false} allowDecimals={false} />
            <Tooltip contentStyle={{ background: "hsl(var(--popover))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 13 }} cursor={{ fill: "hsl(var(--accent))" }} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            {packers.map((p, i) => <Bar key={p} dataKey={p} stackId="a" fill={COLORS[i % COLORS.length]} />)}
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};
